import profitOverview from './profit_overview'

export default {
  ...profitOverview
}
